<template>
  <q-page-container>
    <q-page class="q-pa-md">
      <section class="section-service ">
        <q-tab-panel class="col-12 row items-center">
          <FormOsDesobstructionRequest
            :listWriteOffCode="listWriteOffCode"
            @saveSchemaRequest="requestData => saveSchemaRequest(requestData)"
          />
        </q-tab-panel>
      </section>
    </q-page>
  </q-page-container>
</template>

<script>
import {useQuasar} from 'quasar'
import { ref, reactive, onMounted} from "vue";
import FormOsDesobstructionRequest from "@/components/RequestOsForms/FormOsDesobstructionRequest";
import LowProductionServices from "../../services/LowProductionServices";
   

export default {
  name: "Timer",
  components: {
    FormOsDesobstructionRequest,
  },
  props: {},

  setup(){
    const $q = useQuasar();
    const lowProductionServices = new LowProductionServices();
    const listTypeOS = reactive([
      'REFAZER MANUTENÇÃO',
      'DESOBSTRUÇÃO DE INSTALAÇÃO'
    ]);
    const listWriteOffCode = ref([]);
 
    let contract = reactive({
      osRequests: [],
    });
    let confirmationReplicateWriteOffCode = ref(false);
    let modalReplicateWriteOffCode = ref(false);
    

    function _getWriteOffCodeActives() {
      // getWriteOffCodeActivesByType(lowtype)
      
      lowProductionServices.getWriteOffCodeActives().then((response) => {
        listWriteOffCode.value = response;
      })
    }

    function openConfirmationReplicateWriteOffCode() {
     
    }

    function replicateWriteOffCode() {
     
    }

    function cancelReplicate() {
      confirmationReplicateWriteOffCode.value = false;
      for (let item of contract.osRequests) {
        item.replicate = false;
      }
    }

     function saveSchemaRequest(requestData) {
      let validate = false;

      requestData.typeOS == 'REFAZER MANUTENÇÃO' 
      ? validate = _validateRedoMaintenanceSchemaRequest(requestData) :
        validate = _validateInstallationClearanceSchemaRequest(requestData)
      
      if (validate == false) return;

      let schemaRequest = {
        typeOS: requestData.typeOS,
        datePrimary: requestData.datePrimary,
        hourInitialPrimary: requestData.hourInitialPrimary,
        hourFinishPrimary: requestData.hourFinishPrimary,

        dateSecundary: requestData.dateSecundary,
        hourInitialSecundary: requestData.hourInitialSecundary,
        hourFinishSecundary: requestData.hourFinishSecundary,
        motivoValue: requestData.motivoValue,
        schedulingValue: requestData.schedulingValue,
        statusOS: requestData.statusOS,
        writeOffCode: requestData.writeOffCode,
        observation: requestData.observation,
        check: true,
        replicate: requestData.replicate,
        source: requestData.source
      }
    }

    function _validateRedoMaintenanceSchemaRequest(requestData) {

      if (
        requestData.motivoValue == ''
        ||requestData.date1 == '' 
        ||requestData.date2 == '' 
        || requestData.typeOS == ''
      ) {
        $q.notify({
          message: "Apenas o campo observação nao é obrigatorio.",
          color: "red-9",
          position: 'top',
          timeout: 3000
        })
        return false;
      }
      return true;
    }

    function _validateInstallationClearanceSchemaRequest(requestData) {

      if (
        requestData.date1 == '' 
        ||requestData.date2 == '' 
        || requestData.typeOS == ''
      ) {
        $q.notify({
          message: "Apenas o campo observação nao é obrigatorio.",
          color: "red-9",
          position: 'top',
          timeout: 3000
        })
        return false;
      }
      return true;
    }

    onMounted(() => {
      _getWriteOffCodeActives();
    })

    return{
      listWriteOffCode,
      confirmationReplicateWriteOffCode,
      modalReplicateWriteOffCode,
      listTypeOS,
      openConfirmationReplicateWriteOffCode,
      replicateWriteOffCode,
      cancelReplicate,
      contract,
      saveSchemaRequest
    }
  },
  emits: [],
};
</script>

<style scoped>
</style>